import { createSelector } from 'reselect';
import { AppState } from '$/store';
import * as Bixby from '$/core';

const getIsCurrentPortfolioCompanyPublic = ({ releaseFeatureFlagsState, portfolioState }: AppState) => {
  return !!(
    releaseFeatureFlagsState &&
    portfolioState &&
    portfolioState.currentCompany &&
    portfolioState.currentCompany.isSECPublic &&
    (releaseFeatureFlagsState.data || []).some(
      _ => _.id === Bixby.Configuration.releaseFeatureFlagPublicCompanies && _.isEnabled
    )
  );
};

export const getIsCurrentPortfolioCompanyPublicState = createSelector(
  [getIsCurrentPortfolioCompanyPublic],
  (isCurrentPortfolioCompanyPublic: boolean) => ({ isCurrentPortfolioCompanyPublic })
);
